import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";

import ExpandOrShrinkIcon from "../../../../../Components/UI/DropDown/ExpandOrShrinkIcon";

import {
  RequestAgentPolicies,
  RequestMoveAgentPolicy,
} from "../../../../../store/actions/integrationsActions";

const Dropdown = ({ title, selectedItem, items = [], onItemSelect, fadeEmpty = false, onMove }) => {
  const [open, setOpen] = useState(true);

  const faded = fadeEmpty && items.length === 0;

  return (
    <div className="dropdown">
      <div
        className={classNames("dropdown__title", {
          "dropdown__title--faded": faded,
        })}
        onClick={() => setOpen((state) => !state)}>
        {title}({items.length}) <ExpandOrShrinkIcon expanded={open} collapsed={false} />
      </div>
      {open && items.length > 0 ? (
        <div className="dropdown__items">
          {items.map((item, i) => (
            <div className="dropdown__item" onClick={() => onItemSelect(title, item)} key={i}>
              <p
                className={`dropdown__item__name dropdown__item__name--${item.enabled ? "enabled" : "disabled"}`}
                title={item.name}>
                {item.name}
              </p>
              {selectedItem?.id === item?.id ? <div className="dropdown__item__active" /> : null}
              <span className="dropdown__item__left">
                <span className="priority">{item.priority}</span>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    onMove(item?.id, "up");
                  }}
                  className={classNames("controller", {
                    controller__disabled: item.priority <= 1,
                  })}>
                  <svg width="16" height="16" viewBox="0 0 1024 1024">
                    <path d="M512 85.333333l249.6 298.666667H262.4z" fill="currentColor" />
                    <path d="M426.666667 320h170.666666v576h-170.666666z" fill="currentColor" />
                  </svg>
                </span>
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    onMove(item?.id, "down");
                  }}
                  className={classNames("controller", {
                    controller__disabled: item.priority >= items.length,
                  })}>
                  <svg width="16" height="16" viewBox="0 0 1024 1024">
                    <path d="M512 938.666667L262.4 640h499.2z" fill="currentColor" />
                    <path d="M426.666667 128h170.666666v576h-170.666666z" fill="currentColor" />
                  </svg>
                </span>
              </span>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

const AgentPoliciesSidebar = ({ onPolicySelect, selectedPolicy, selectedHost }) => {
  const dispatch = useDispatch();

  const agentPolicies = useSelector((state) => state.integrations.agentPolicies);

  useEffect(() => {
    dispatch(RequestAgentPolicies(selectedHost));
  }, [dispatch, selectedHost]);

  useEffect(() => {
    const isSelectedStillExists = agentPolicies.some((p) => p.id === selectedPolicy?.id);

    if (agentPolicies.length > 0) {
      if (!selectedPolicy || !isSelectedStillExists) {
        onPolicySelect("", agentPolicies[0]);
      }
    } else if (agentPolicies.length === 0) {
      onPolicySelect("", null);
    }
  }, [agentPolicies, selectedPolicy, onPolicySelect]);

  const moveHandler = (id, direction) => {
    dispatch(RequestMoveAgentPolicy({ id, direction, host: selectedHost }));
  };

  return (
    <div className="agent-policies-sidebar">
      <Dropdown
        title="Policies"
        selectedItem={selectedPolicy}
        items={agentPolicies}
        onItemSelect={onPolicySelect}
        onMove={moveHandler}
      />
    </div>
  );
};

export default AgentPoliciesSidebar;
